<template>
	<div>
		<v-data-table
			:headers="tableHeaders"
			:items="getAlarmItemsForTable"
			hide-default-footer
			class="elevation-1"
		>
			<template v-slot:top>
				<v-toolbar
					flat
				>
					<v-toolbar-title>Alarms</v-toolbar-title>
					<v-divider
						class="mx-6"
						inset
						vertical
					></v-divider>

					<v-spacer></v-spacer>

					<AddAlarmDialog/>
				</v-toolbar>
			</template>
			<template v-slot:item.alarmType="{ item }">
				<v-chip
					:color="getColorForAlarmType(item.alarmType)"
					dark
				>
					{{ getAlarmTypeString(item.alarmType) }}
				</v-chip>
			</template>

			<template v-slot:item.actions="{ item }">
				<DeleteAlarmButton
					:alarm="item"
				/>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import {FETCH_ALARMS} from "@/store/actions.type";
import {mapGetters} from "vuex";
import {Intention} from "@/common/intentions.type";
import AddAlarmDialog from "@/components/AddAlarmDialog";
import DeleteAlarmButton from "@/components/DeleteAlarmButton";
import moment from 'moment';

export default {
	name: "home",
	components: {
		AddAlarmDialog,
		DeleteAlarmButton,
	},
	data() {
		return {
			tableHeaders: [
				{
					text: 'I want to',
					align: 'start',
					sortable: false,
					value: 'alarmType',
				},
				{
					text: 'Stock | Exchange',
					value: 'stockExchange',
				},
				{
					text: 'Base Price',
					value: 'basePrice',
				},
				{
					text: 'Take action',
					value: 'takeAction',
				},
				{
					text: 'Currently At',
					value: 'currentlyAt',
				},
				{
					text: 'Refreshes',
					value: 'refreshes',
				},
				{
					text: 'Actions',
					value: 'actions',
					sortable: false
				}
			]
		}
	},
	computed: {
		...mapGetters(["alarmsCount", "alarms"]),

		getAlarmItemsForTable() {
			if (this.alarmsCount > 0) {
				return this.alarms.map((alarm, index) => {
					let row = {
						id: index,
						alarmId: alarm.id,
						alarmType: alarm.intention_id,
						stockExchange: `${alarm.stock.description} | ${alarm.stock.exchange.exchange_name}`,
						basePrice: `${alarm.base_price.currency} ${alarm.base_price.amount}`,
						takeAction: `${alarm.stock.currentPrice.currency} ${this.calculateTakeActionPrice(alarm)} (${this.prettyDesiredDelta(alarm)})`,
						currentlyAt: `${alarm.stock.currentPrice.currency} ${alarm.stock.currentPrice.amount}`,
						refreshes: "Never",
						stockId: alarm.stock.id
					}

					if (typeof alarm.to_be_refreshed_at !== "undefined") {
						row.refreshes = `${this.formatDate(alarm.to_be_refreshed_at)} (Every ${alarm.refresh_period_days} days)`;
					}

					return row;
				});
			}

			return [];
		},


	},
	mounted() {
		this.fetchAlarms()
	},
	methods: {
		fetchAlarms() {
			this.$store.dispatch(FETCH_ALARMS)
		},
		isSellAlarm(alarm) {
			return Intention.getIntention(alarm.intention_id) === Intention.sell()
		},
		calculateTakeActionPrice(alarm) {
			if (this.isSellAlarm(alarm)) {
				return parseFloat(alarm.base_price.amount) * (100 + alarm.desired_delta) / 100;
			}

			return parseFloat(alarm.base_price.amount) * (100 - alarm.desired_delta) / 100;
		},
		prettyDesiredDelta(alarm) {
			if (this.isSellAlarm(alarm)) {
				return `+${alarm.desired_delta}%`;
			}

			return `-${alarm.desired_delta}%`;
		},
		formatDate(dateString) {
			let date = moment(dateString, "YYYY-MM-DD");

			return date.format("DD-MM-YYYY")
		},
		getColorForAlarmType(intention_id) {
			if (Intention.getIntention(intention_id) === Intention.buy()) {
				return 'green';
			} else {
				return 'red';
			}
		},
		getAlarmTypeString(intention_id) {
			return Intention.getIntention(intention_id).toUpperCase();
		}
	}
}
</script>

<style scoped>
#alarms-list-container {
	margin-top: 24px;
}

</style>